import { WpModes } from "../../constants";

export interface WorkPlaceCatFilter {
  category: string;
  faIcon: string;
  faColor: string;
  name: string;
  bgColor: string;
  tagCount: number;
  showSearchBox: boolean;
  isSearching?: boolean | null;
  isMultiSel?: boolean | null;
  tagMatchedAll: boolean; // True= Matched All, False = No
  // empIncludePostRelated?: boolean | null;
  empFilterType: WpEmpFilterType;
  tags: WorkPlaceTagFilter[] | null;
  isCollapse: boolean;
}

export interface WorkPlaceTagFilter {
  category: string;
  tagId: number;
  name: string;
  selected?: boolean | null;
  faColor: string | null;
  bgColor: string | null;
  faIcon: string | null;
  unreadCount?: number | null;
}

export interface tb_WpTagMasterCat {
  category?: string | null;
  faIcon?: string | null;
  faColor?: string | null;
  enabled?: boolean | null;
  usedCount?: number | null;
  lastSync?: Date | null;
  name?: string | null;
  bgColor?: string | null;
  tagCatIdx?: number | null;
  seq?: number | null;
}


export interface WorkPlaceTagUnreadSignalR {
  wpMode: WpModes,
  tagId: number,
  memberId: number,
  unreadCount?: number
}

export interface WorkPlaceFilterSel {
  // type: string;
  // icon: string;
  // text: string;
  // keyCode: string;
  cat: string;
  icon: string;
  color: string;
  bgColor: string;
  tagName: string;
  tagId: number;
}

export interface QuillFileUpload {
  id: string;
  blobUrl: string;
  atype: ATypes;
  fileName: string;
}

export interface QuillTagData {
  id: string;
  tagId: number;
  tagName: string;
}

export interface sp_WpFindTag {
  tagId: number;
  category: string;
  name: string;
  // faColor: string;
  // bgColor: string;
  // faIcon: string;
}

export interface tb_WpTagMaster {
  tagId?: number | null;
  category?: string | null;
  name?: string | null;
  tagKeyId?: string | null;
  enabled?: boolean | null;
  usedCount?: number | null;
  syncDate?: string | null;
  members?: tb_WpTagMasterMember[];
  authMobileNo?: string | null;
}

export interface tb_WpTagMasterMember {
  uid: string | null;
  parentTagId: number | null;
  memberTagId: number | null;
  parentTagKeyId: string | null;
  memberRole: number | null;
  rowCompute: number | null;
  isManual: boolean | null;
  remark: string | null;
  memberName: string | null;
}


export enum ATypes {
  image = "image",
  file = "file",
  tag = "tag"
}

export enum MemberRole {
  Owner = 1,
  Follower = 2,
  TagMe = 3,
  MyPost = 4,
  Flag = 5, /* Post ที่ธง หรือ งานที่ติดธง */
  Organize = 6,
  PersonFollow = 7,
  Observer = 8, /*สำหรับอยู่ใน tag แบบ observer ไม่แจ้งเตือน ไม่มี unread*/
  Subscribe = 9,
  All = 0,

  TaskMine = 20, /* task ที่เราเป็นคนทำ ถูกมอบหมายให้ทำ */
  TaskAssigner = 21, /* task ที่เราเป็นคนมอบหมาย */
  TaskReqBy = 22,
  TaskCreator = 23,
  TaskRelated = 24, /* task ที่เราไปมีส่วนร่วม อาจจะผ่านการ tag */
}

export enum TaskStatus {
  ToDo = 1,
  Finished = 2,
  Cancel = 3,
  OnGoing = 4,
  Hold = 5,
}

export enum PostCommands {
  MarkAsUnread,
  SharePost,
  Snooze,
  Flag,
  PostStatus,
  PostInfo,
  RequestApproval,
  DeletePost,
  ConvertToTask,
  CreateSubTask,
  RecurranceSetting,
  GoToMainTask,
  UnSubscribe,
  ChangeIcon
}

export enum WpStatus {
  Open = 1,
  Cancel = 2,
  Postpone = 4,
  Close = 3,
}

export enum WpPostType {
  None = 0,
  ChangeStatus = 1,
  RemoveTag = 2,
  ChangePostInfo = 3,
  Subscribe = 5, UnSubscribe = 6,
  DSignLog = 7
}

export enum WpEmpFilterType {
  Poster = 1,
  Tagged = 2,
  InPost = 3,
  TaskOwner = 4
}


export enum WpFilterTaskDueMode {
  None = 0,
  ComingDue = 1,
  OverdDue = 2
}

export interface WpEmoji {
  nm: string; /* Emoji Name */
  ji: string; /* Emoji Symbol */
  mbr: string; /* Emoji Members */
}

export interface WpTitle {
  postId: string, title: string, body: string, icon: string, lastChatDate: string, abbrName: string, abbrFore: string, abbrBack: string
  , lastChatText: string, unread: number, lastChatImg: string | null, flag: boolean | null, snooze: boolean | null, status: WpStatus, draft: boolean | null
  , taskStatus: TaskStatus | null, planFinishedDate: Date | null, actFinishedDate: Date | null, isTaskOverdue: boolean | null, isSubTask: boolean | null, isLoadingSub: boolean | null, subTaskCount: number | null, parentTaskId: string | null
  , approveStatus: string | null
}
export interface WpConver {
  bodyHtml: string | null;
  isEdit: boolean | null;
  hasChild: boolean | null;
  postDateTime: Date | null;
  postById: number | null;
  postByName: string | null;
  abbrName: string | null;
  foreColor: string | null;
  bgColor: string | null;
  pictureUrl: string | null;
  isFromMe: boolean | null;
  isRead: boolean | null;
  postId: string;
  postIdParent: string;
  emojis: WpEmoji[] | null;
  isUnsend: boolean | null;
  postType: WpPostType;
  postTypeInfo: string | null;
}

export interface WpMemberRoleUnread {
  memberId: number;
  unreadOwner: number;
  unreadFollower: number;
  unreadTagMe: number;
  unreadMyPost: number;
  unreadFlag: number;
  unreadOrganize: number;
  unreadPersonFollow: number;
  unreadObserver: number;
  reloadTitle: boolean;

  taskUnreadMine: number;
  taskUnreadAssigner: number;
  taskUnreadRequestBy: number;
  taskUnreadFlag: number;
  taskUnreadRelated: number;
  taskUnreadObserver: number;
}

//export interface WpPostTag { tagId: number | null; category: string | null; name: string | null; faIcon: string | null; faColor: string | null; }
export interface WpPostInfoTag { tagId: number | null; category: string | null; name: string | null; faIcon: string | null; faColor: string | null; bgColor: string | null }
export interface WpPostInfo {
  wpMode: WpModes | null;
  postId: string | null;
  title: string;
  icon: string;
  abbrName: string;
  abbrFore: string;
  abbrBack: string;
  tags: WpPostInfoTag[];
  flag: boolean;
  snooze: boolean;
  isYourPost: boolean;
  canChangeStatus: boolean;
  canDeletePost: boolean;
  youIsMember: boolean;
  status: WpStatus;
  statusById: number | null;
  statusDate: Date | null;
  statusRemark: string | null;
  statusByName: string | null;

  taskStatus: TaskStatus | null;
  members?: any[] | null;
  projectId?: number | null;
  projectName?: number | null;
  respondId?: number | null;
  assignerId?: number | null;
  requestBy?: number | null;
  planStartDate?: Date | null;
  planFinishedDate?: Date | null;
  actFinishedDate?: Date | null;
  isSubTask?: boolean | null;
  subTaskCount?: number | null;
  parentTaskId?: string | null;
  isTaskOverdue?: boolean | null;
  approveStatus?: string | null;
}

export interface WpSliceData {
  activePostInfo: WpPostInfo;
  activePostInfoLoading: boolean;
  postIdInstant: string | null;
  // activeTaskInfo: WpPostInfo;
  // activePostId: string | null;
  // activePostTitle: string | null;
  // activePostAbbr: string | null;
  // activePostAbbrFore: string | null;
  // activePostAbbrBack: string | null;
  // activePostTags: WpPostTag[];
  activeMemberRole: MemberRole;


  titleLoading: boolean;
  titleFromTaskDashboard: boolean;
  titleErrMsg: string | null;
  titles: WpTitle[];

  converLoading: boolean;
  converErrMsg: string | null;
  convers: WpConver[];
  converLoadingMore: boolean;
  converHasMore: boolean;

  roleUnread: WpMemberRoleUnread;

  tagFilterSelected: WorkPlaceTagFilter[];
  isEmbChatOnly?: boolean | null;
  filterNotClose: boolean;
  // filterTaskDueMode: WpFilterTaskDueMode,

  titlesTk: WpTitle[];
  activeMemberRoleTk: MemberRole;
  tagFilterSelectedTk: WorkPlaceTagFilter[];
  taskStatusFilter: TaskStatus[];
  filterNotCloseTk: boolean;

  shareFilterWpTask: boolean;
  keywordWp: string;
  keywordTk: string;
  searchTriggerWp: number;
  searchTriggerTk: number;

  dllEmployee?: any[] | null;
  tagUnreadOnSignalR: WorkPlaceTagUnreadSignalR[];

  taskDash: any;
  taskDashLoading: boolean;
  taskDashStatusLoading: boolean;

  taskDashByDivRsp: any[],
  taskDashByDivAsg: any[],
  taskDashByDivReq: any[],
  taskDashByDivLoading: boolean,

  taskDashTags: any;
  taskDashTagsLoading: boolean;
  taskDashFilterTagId: number | null;

  taskDashRecurance: any[];
  taskDashRecuranceLoading: boolean;

  createSubTaskFromTaskId?: string | null;

  tagMasterCats: tb_WpTagMasterCat[];
}

export interface WpLoadTagMemberDtl {
  parentTagId: number | null;
  memberId: number | null;
  memberTagId: number | null;
  memberRole: number | null;
  memberRoleText: string | null;
  displayName2: string | null;
  pictureUrl: string | null;
  divisionName: string | null;
  departmentName: string | null;
  positionName: string | null;
}


export enum WpActionTypes {
  API_OK = "@@sp/API_OK",
  API_ERR = "@@sp/API_ERR",
  SET_ACTIVE_POSTID2 = "@@wp/SET_ACTIVE_POSTID2",
  SET_CREATE_SUB_TASK = "@@wp/SET_CREATE_SUB_TASK",
  // LOAD_POST_TITLE = "@@wp/LOAD_POST_TITLE", -> use two type bellow
  LOAD_POST_TITLE_WP = "@@wp/LOAD_POST_TITLE_WP",
  LOAD_POST_TITLE_TK = "@@wp/LOAD_POST_TITLE_TK",
  LOAD_POST_CONVER = "@@wp/LOAD_POST_CONVER",
  LOAD_MORE_POST_CONVER = "@@wp/LOAD_MORE_POST_CONVER",
  APPEND_POST_CONVER = "@@wp/APPEND_POST_CONVER",
  LOAD_POST_INFO2 = "@@wp/LOAD_POST_INFO2",
  SET_ACTIVE_MEMBERROLE = "@@wp/SET_ACTIVE_MEMBERROLE",
  SET_POST_INFO_ON_SIGNALR = "@@wp/SET_POST_INFO_ON_SIGNALR",
  SET_POST_INFO_ONLY = "@@wp/SET_POST_INFO_ONLY",
  GET_ROLE_UNREAD_COUNT = "@@wp/GET_ROLE_UNREAD_COUNT",
  UPDATE_POST_UNREAD_COUNT = "@@wp/UPDATE_POST_UNREAD_COUNT",
  SET_FILTER_SELECTED = "@@wp/SET_FILTER_SELECTED",
  // SET_FILTER_TASK_DUEMODE = "@@wp/SET_FILTER_TASK_DUEMODE",
  SET_TASK_STATUS_FILTER = "@@wp/SET_TASK_STATUS_FILTER",
  SET_SHARE_FILTER_WP_TASK = "@@wp/SET_SHARE_FILTER_WP_TASK",
  SET_KEYWORD = "@@wp/SET_KEYWORD",
  CLEAR_ALL_FILTER = "@@wp/CLEAR_ALL_FILTER",
  SET_FLAG = "@@wp/SET_FLAG",
  SET_SNOOZE = "@@wp/SET_SNOOZE",
  SET_UNREAD = "@@wp/SET_UNREAD",
  TOGGLE_POST_EMOJI = "@@wp/TOGGLE_POST_EMOJI",
  MARK_POST_UNSEND = "@@wp/MARK_POST_UNSEND",
  CHANGE_POST_STATUS = "@@wp/CHANGE_POST_STATUS",
  SET_IS_EMB_CHAT_ONLY = "@@wp/SET_IS_EMB_CHAT_ONLY",
  SET_DRAFT_POST = "@@wp/SET_DRAFT_POST",
  LOAD_DLL_EMPLOYEE = "@@wp/LOAD_DLL_EMPLOYEE",
  TAG_UNREAD_ON_SIGNALR = "@@wp/TAG_UNREAD_ON_SIGNALR",
  REMOVE_POST_TITLE_FROM_LIST = "@@wp/REMOVE_POST_TITLE_FROM_LIST",
  WP_LOAD_TASK_DASH = "@@/WP_LOAD_TASK_DASH",
  WP_LOAD_TASK_DASHBOARD_BY_DIV = "@@/WP_LOAD_TASK_DASHBOARD_BY_DIV",
  WP_LOAD_TASK_DASH_TAGS = "@@/WP_LOAD_TASK_DASH_TAGS",
  WP_LOAD_TASK_DASH_STATUSRANGE = "@@/WP_LOAD_TASK_DASH_STATUSRANGE",
  WP_LOAD_TASK_DASH_RECURANCE = "@@/WP_LOAD_TASK_DASH_RECURANCE",
  WP_LOAD_SUB_TASK = "@@/WP_LOAD_SUB_TASK",
  WP_SET_TASK_DASH_FILTER_TAGID = "@@/WP_SET_TASK_DASH_FILTER_TAGID",
  WP_TAG_MASTER_CAT_LOAD = "@@/WP_TAG_MASTER_CAT_LOAD",
  WP_SET_POSTID_FOR_INSTANCE = "@@/WP_SET_POSTID_FOR_INSTANCE",
  MARK_AS_READ = "@@wp/MARK_AS_READ",
  SET_POST_ICON = "@@wp/SET_POST_ICON",
  SORT_TITLES_TK_LOCAL = "@@wp/SORT_TITLES_TK_LOCAL",
}

